import React, { useState, useEffect, ChangeEvent } from "react";
import { toast } from "react-toastify";
import {
  exportJsonToExcelStyle,
  readExcelFile,
  workbookToJsonArray,
} from "../../../../AdminApi/commFunc";
import { useApi } from "../../../../hooks/useApi";
import FileUploadBtn from "../../../Button/FileUploadBtn";
import LineBtn from "../../../Button/LineBtn";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import AlertModal from "../../../Modal/AlertModal";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import ManagerPwInputModal from "../../../Modal/ManagerPwInputModal";
import { FileNameBox } from "../../Benefit/Coupon/CouponPointRegisterModal/MassiveRegister";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import dayjs from "dayjs";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";

interface UplusDataUploadModalProps extends DefaultModalCommonProps {}

export default function UplusDataUploadModal({
  closeEvent,
  confirmEvent,
}: UplusDataUploadModalProps) {
  const [askDataUpdateModal, setAskDataUpdateModal] = useState(false);
  const [managerPwInputModal, setManagerPwInputModal] = useState(false);
  const [dataUpdate, setDataUpdate] = useState(false);
  const [file, setFile] = useState<any[] | null>(null);
  const [fileName, setFileName] = useState<undefined | string>(undefined);
  const [uploadSuccessModal, setUploadSuccessModal] = useState(false); // 업로드 성공 모달
  const [uploadFailModal, setUploadFailModal] = useState(false); // 업로드 실패 모달
  const [uploadErrorModal, setUploadErrorModal] = useState(false); // 업로드 에러 모달
  const [failList, setFailList] = useState<string[][]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: dataUpdate ? `uplus2` : undefined,
    data: {
      list: file,
    },
  });

  const uploadExcel = (e: ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.files);

    if (e.target.files?.item(0)) {
      const file = e.target.files[0];

      setFileName(file.name ?? "");

      setIsLoading(true);

      readExcelFile(
        file,
        (workBook) => {
          console.log(workBook);

          if (workBook) {
            const json = workbookToJsonArray(workBook, 5) as any[];

            console.log(json);

            const uploadableFile = json?.map((item) => {
              return {
                index: item["Index"],
                type: item["Type"],
                code: item["Code"],
                phone: item["Phone"],
                name: item["Name"],
                birth: dayjs(item["Birth"]).format("YYYY-MM-DD"),
                combined: item["Combined"],
              };
            });

            console.log(uploadableFile);

            setFile(uploadableFile);

            setIsLoading(false);
          }
        },
        () => setUploadFailModal(true)
      );
    }
  };

  useEffect(() => {
    if (response?.status === 201) {
      setDataUpdate(false);

      if (response?.data?.faillist?.length > 0) {
        // 실패 내역
        const eachFailList: string[][] = [];
        response?.data?.faillist?.forEach(
          (f: {
            index: string;
            type: string;
            code: string;
            phone: string;
            name: string;
            birth: string;
            combined: string;
            err: number;
          }) => {
            eachFailList.push([
              f?.index ?? "",
              f?.type ?? "",
              f?.code ?? "",
              f?.phone ?? "",
              f?.name ?? "",
              f?.birth ?? "",
              f?.combined ?? "",
              String(f?.err),
            ]);
          }
        );

        console.log(eachFailList);

        setFailList(eachFailList);

        setUploadErrorModal(true);
      } else {
        // 성공 내역
        setUploadSuccessModal(true);
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "데이터를 업데이트 하는 데에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="유플러스 결합 고객 데이터 업로드"
        closeEvent={() => closeEvent()}
        confirmEvent={() => setAskDataUpdateModal(true)}
        confirmBtnText={file ? `총 ${file?.length}건 업로드` : "업로드"}
        confirmDisabled={file === null}
        isSmallModal={true}
      >
        <>
          <ModalRow style={{ alignItems: "flex-start" }}>
            <ModalLabel>파일 업로드</ModalLabel>

            <div style={{ width: "100%" }}>
              <Flex gapSize={10}>
                <FileUploadBtn
                  btnText="파일 선택"
                  btnColor="mint"
                  btnHeight={38}
                  onChangeEvent={uploadExcel}
                  isDisabled={fileName ? true : false}
                />

                <LineBtn
                  icon="file_download"
                  btnText="양식 다운로드"
                  btnHeight={38}
                  btnClickEvent={() => {
                    window.location.href =
                      "https://storage.googleapis.com/linkidimage/%E1%84%85%E1%85%B5%E1%86%BC%E1%84%8F%E1%85%B5%E1%84%83%E1%85%B3_%E1%84%8B%E1%85%B2%E1%84%91%E1%85%B3%E1%86%AF%E1%84%85%E1%85%A5%E1%84%89%E1%85%B3_%E1%84%80%E1%85%A9%E1%84%80%E1%85%A2%E1%86%A8%E1%84%83%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%90%E1%85%A5%E1%84%8B%E1%85%A5%E1%86%B8%E1%84%85%E1%85%A9%E1%84%83%E1%85%B3%E1%84%8B%E1%85%A3%E1%86%BC%E1%84%89%E1%85%B5%E1%86%A8.xlsx";

                    toast.success("데이터 업로드 양식 다운로드 완료");
                  }}
                />
              </Flex>

              {fileName && (
                <Flex style={{ marginTop: 10 }} gapSize={10}>
                  <FileNameBox fileName={fileName}>{fileName}</FileNameBox>

                  <LineBtn
                    btnText="삭제"
                    btnHeight={38}
                    btnClickEvent={() => {
                      setFile(null);
                      setFileName(undefined);
                    }}
                  />
                </Flex>
              )}
            </div>
          </ModalRow>

          {loading && <Loader />}

          {/* 업로드 의사 묻기 */}
          {askDataUpdateModal && (
            <AlertModal
              title={`유플러스 결합 고객 데이터를
            업로드 하시겠습니까?`}
              desc={`${getThousandComma(file?.length ?? 0)}건 업로드`}
              cancelEvent={() => setAskDataUpdateModal(false)}
              confirmEvent={() => {
                setManagerPwInputModal(true);
                setAskDataUpdateModal(false);
              }}
              btnColor="red"
            />
          )}

          {/* 업로드 실패 */}
          {uploadFailModal && (
            <AlertModal
              title={`파일 업로드에 실패했어요.
        다시 시도해 보세요.`}
              customCancelBtn={<></>}
              confirmEvent={() => {
                setUploadFailModal(false);
              }}
            />
          )}

          {/* 업로드 성공 */}
          {uploadSuccessModal && (
            <AlertModal
              title={`데이터 ${getThousandComma(
                file?.length ?? 0
              )}건 업로드 완료`}
              desc={`신규 고객: 결합코드 발송 필요\n기존 고객: 링키드 결합 상태 변경 완료`}
              btnColor="mint"
              customCancelBtn={<></>}
              confirmEvent={() => {
                closeEvent();
                if (confirmEvent) confirmEvent();
                setUploadSuccessModal(false);
              }}
            />
          )}

          {/* 업로드 오류 */}
          {uploadErrorModal && (
            <AlertModal
              title={
                <>
                  {getThousandComma(file?.length ?? 0)}건 중{" "}
                  <strong>
                    {getThousandComma(failList?.length)}건 업로드 실패
                  </strong>
                  <br />
                  오류를 수정하여 재 업로드 해주세요.
                </>
              }
              desc={`업로드 성공: ${getThousandComma(
                (file?.length ?? 0) - (failList?.length ?? 0)
              )}건\n업로드 실패: ${
                failList?.length
              }건\n-> 오류 확인/수정 후 재 업로드 요망\n`}
              customCancelBtn={<></>}
              confirmText="오류 내역 다운로드"
              btnColor="red"
              confirmEvent={() => {
                const infoStyle = {
                  fill: {
                    bgColor: { rgb: "FCE4D6" },
                    fgColor: { rgb: "FCE4D6" },
                  },
                  alignment: { vertical: "top", wrapText: true },
                  font: { sz: "10" },
                };

                let titleDescHeader1 = [
                  {
                    v: "- Error 열의 오류 내용 확인 후 수정하여 전체 데이터 재 업로드",
                    t: "s",
                    s: {
                      ...infoStyle,
                      font: { color: { rgb: "C00000" }, bold: true },
                    },
                  },
                ];

                let titleDescHeader2 = [
                  {
                    v: "- 오류 케이스",
                    t: "s",
                    s: { ...infoStyle, font: { bold: true } },
                  },
                ];

                let titleDesc = [
                  {
                    v: `   1. 중복 결합 불가 : Type이 New이고, Combined가 Y인 경우\n   2. 중복 휴대폰 번호 : Type이 New이고, 이미 등록된 고객의 휴대폰 번호가 입력된 경우\n   3. 연령 기준 미달 : Type이 New이고, 고객의 생년월일이 결합 불가한 경우\n   4. 코드 매핑 불가 : Type이 New이고, 결합 코드가 입력된 경우\n   5. 업로드 불가 : Type이 New이고, 결합 코드를 제외한 다른 항목이 비어있는 경우\n      Type이 Change이고, 항목이 비어있는 경우\n   6. 수정 불가항목 변경 : Type이 Change이고, 고객의 결합 코드, 생년월일이 변경된 경우\n   7. 변경 항목 없음 : Type이 Change이고, 아무 항목도 변경되지 않은 경우 -> 해당 오류 케이스의 데이터는 삭제하고 업로드 할 것\n   8. 미등록 결합 코드 : Type이 Change이고, 고객의 결합 코드가 등록되지 않은 경우\n   9. 코드 발급 불가: 발급 가능한 코드가 없는 경우`,
                    t: "s",
                    s: { ...infoStyle },
                  },
                ];

                exportJsonToExcelStyle(
                  "유플러스 결합 고객 데이터 오류 리스트",
                  [titleDescHeader1, titleDescHeader2, titleDesc],
                  undefined,
                  [
                    "Index",
                    "Type",
                    "Code",
                    "Phone",
                    "Name",
                    "Birth",
                    "Combined",
                    "Error",
                  ],
                  "링키드_유플러스_고객데이터오류리스트",
                  "Error List",
                  failList,
                  172.5,
                  [
                    { s: { r: 0, c: 0 }, e: { r: 0, c: 8 - 1 } },
                    { s: { r: 1, c: 0 }, e: { r: 1, c: 8 - 1 } },
                    { s: { r: 2, c: 0 }, e: { r: 2, c: 8 - 1 } },
                    { s: { r: 3, c: 0 }, e: { r: 3, c: 8 - 1 } },
                  ],
                  [{ hpx: 17.25 }, { hpx: 15 }, { hpx: 15 }, { hpx: 150 }]
                );

                toast.success("오류 내역 다운로드 완료");

                if (confirmEvent && file && file?.length > failList?.length)
                  confirmEvent();
                closeEvent();
              }}
            />
          )}

          {managerPwInputModal && (
            <ManagerPwInputModal
              closeEvent={() => setManagerPwInputModal(false)}
              confirmEvent={() => {
                setManagerPwInputModal(false);
                setDataUpdate(true);
              }}
            />
          )}

          {isLoading && <Loader />}
        </>
      </DefaultModalLayout>
    </>
  );
}
